export const FilesSectionList = {
  flow: 'column',
  childExtends: 'FileItem',
  fontSize: 'Z2',
  align: 'stretch',
  gap: 'X1',
  childrenAs: 'state',
  children: [
    {
      type: 'components',
      key: 'Logo',
      value: {
        Img: {},
      },
    },
    {
      type: 'components',
      key: 'Header',
      value: {
        Logo: {},
      },
    },
  ],
};